App = App || {};

App.ManageProfiles = (function ($, Vue) {
	"use strict";

	function init(rootElement) {
		rootElement = rootElement || document.getElementById("manage-profiles");
		if (!rootElement || rootElement.dataset.mounted)
			return;

		rootElement.dataset.mounted = "1";

		new Vue({
			el: rootElement,
			data: {
				fieldDefs: [
					{ key: "nodeName", label: "Name", sortable: true },
					{ key: "email", label: "Email", sortable: true },
					{ key: "dealerName", label: "Dealer", sortable: true },
					{ key: "created", label: "Created", sortable: true },
					{ key: "notes", label: "Notes", sortable: true },
					{ key: "isApproved", label: "", sortable: true, class: "text-center" }
				],
				isLoading: false,
				page: 1,
				pageSize: 10,
				searchTerm: "",
				hideApproved: false,
				sortBy: "nodeName",
				sortDesc: false,
				totalItems: 0,
				firstItem: 0,
				lastItem: 0
			},
			computed: {
				fieldsWithColumnSelect: function () {
					var viewModel = this;
					return viewModel.fieldDefs.map((field) => { 
						var sortedClass = viewModel.sortBy === field.key ? "is-sorted" : "";
						return Object.assign({}, field, { thClass: sortedClass, tdClass: sortedClass });
					});
				},

				totalPages: function () {
					return Math.max(1, Math.ceil((this.totalItems || 0) / (this.pageSize || 1)));
				}			
			},
			methods: {
				provider: function (context) {
					var requestParameters = {
						page: context.currentPage,
						pageSize: context.perPage,
						searchTerm: this.searchTerm,
						hideApproved: this.hideApproved,
						sortBy: context.sortBy || this.sortBy || "",
						sortDir: (context.sortDesc === true) ? "desc" : "asc"
					};

					return $.ajax({
						url: "/api/members/search",
						method: "GET",
						dataType: "json",
						data: requestParameters,
						headers: { "Accept": "application/json" },
						timeout: 15000
					}).then((response) => {
						if (response && response.success) {
							context.currentPage = response.data.page;
							context.perPage = response.data.pageSize;
							this.totalItems = response.data.total;
							this.firstItem = response.data.firstItem;
							this.lastItem = response.data.lastItem;
							return response.data.items;
						}

						context.totalItems = 0;
						return [];

					}).catch((error) => {
						console.error("Members provider error:", error);
						context.totalItems = 0;
						return [];
					});
				},

				toggleHideApproved: function () {
					this.hideApproved = !this.hideApproved;
					this.refresh();
				},

				toggleHideApprovedButtonText: function () {
					return this.hideApproved ? "Show All" : "Hide Approved";
				},

				onToggleItemApproved: function (item) {
					this.$set(item, '_saving', true);
					var isApproved = !item.isApproved;
					var payload = { id: item.id, isApproved: isApproved }
					$.ajax({
						url: "/api/members/set-approval",
						method: "POST",
						contentType: "application/json",
						data: JSON.stringify(payload),
						timeout: 15000
					}).then((response) => {
						if (response && response.success) {
							this.$set(item, 'isApproved', isApproved);
						}
						else {

						}
					}).catch((error) => {
						console.error("Members provider error:", error);
					}).always(() => {
						this.$set(item, '_saving', false); 
					});
				},

				refresh: function () {
					this.$refs.table.refresh();
				},

				formatDate: function (value) {
					if (!value)
						return "";

					const normalizedIsoString = String(value).replace(/(\.\d{3})\d+$/, "$1");
					const date = new Date(normalizedIsoString);

					if (isNaN(date))
						return String(value);

					return date.toLocaleDateString("en-US", {
						year: "numeric",
						month: "2-digit",
						day: "2-digit"
					});
				},

				onRowClicked: function (item, index, evt) {
					if (!item || !item.id || item._saving)
						return;

					App.MemberDetail.open(item.id, () => setTimeout(() => {
						this.refresh();
					}, 900));
				}
			},
			mounted: function () {
				this.$nextTick(() => {
					this.$refs.table.refresh();
				});
			}
		});
	}

	return { init };
})(jQuery, Vue);

App.ManageProfiles.init();
